import type { EmailAuth } from './email-auth';

/**
 * The Firebase SDK, loaded only when a player first signs in, registers, resets their password, uses a sign-in
 * link or picks a social provider, or a social sign-in returns, so the pre-launch gate and every other page load
 * nothing from Firebase.
 */
export const loadEmailAuth = async (): Promise<EmailAuth> => (await import('./browser-email-auth')).browserEmailAuth;
